import Vue from 'vue';
import ElementUI, { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueI18n from 'vue-i18n';
import VConsole from "vconsole";
import App from './App.vue';
import router from './router';
import vueEsign from 'vue-esign'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueI18n);
const i18n = new VueI18n({
	locale: 'zh', // 语言标识
	messages: {
		zh: require('./assets/lang/zh'),
	},
});
if (window.PAGE_CONFIG && window.PAGE_CONFIG.isTestEnvironment === '01') {
	new VConsole();
}

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(ElementUI);
Vue.use(vueEsign);

const myMessage = function (args) {
	Message.closeAll();
	return Message(args);
};
['success', 'warning', 'info', 'error'].forEach(type => {
	myMessage[type] = options => {
		if (typeof options === 'string') {
			options = {
				message: options
			};
		}
		options.type = type;
		return Message(options);
	};
});

myMessage.close = Message.close;
myMessage.closeAll = Message.closeAll;
Vue.prototype.$message = myMessage;
new Vue({
	i18n,
	router,
	render: (h) => h(App),
}).$mount('#app');
